import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { BackendApiService } from '../../services/backend-api.service';
import { BaseUrlConstantsService } from '../../services/base-url-constants.service';
@Component({
  selector: 'app-settings-modal',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule],
  templateUrl: './settings-modal.component.html',
  styleUrl: './settings-modal.component.scss'
})
export class SettingsModalComponent {
  _sensorGroupData: any[] = [];
  sensorKWpowerGroupData: any[] = [];
  assetType: string = 'MOTOR';
  fftBaseValue = 'VEL';
  showKurtosis = false;
  kurt_threshold: number = 0;
  kurt_freq: number = 0;
  kurt_anomaly_counter: number = 0;
  assetStatus: any = 0;
  originalData: any[] = [];

  constructor(
    public dialogRef: MatDialogRef<SettingsModalComponent>, public service: BackendApiService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { console.log(data) }



  ngOnInit() {
    this.originalData = JSON.parse(JSON.stringify(this.data.metrics));
    console.log(this.originalData)
    this.kurt_threshold = this.data.metrics[0].kurt_threshold;
    this.kurt_freq = this.data.metrics[0].kurt_freq;
    this.kurt_anomaly_counter = this.data.metrics[0].kurt_anomaly_counter;
    this.assetStatus = this.data.assetStatus;

    this._sensorGroupData = this.data.metrics.filter((item: any) =>
      !item.metric_type.startsWith("kwrating")
    );

    this._sensorGroupData = this.data.metrics.filter((item: any) =>
      item.metric_type.startsWith("acceleration") || item.metric_type.startsWith("temperature") || item.metric_type.startsWith("displacement")
    );

    this.sensorKWpowerGroupData = this.data.metrics.filter((item: any) =>
      item.metric_type.startsWith("kwrating")
    );

  }

  onInputChange() {
    console.log("Values changed");
  }

  close() {
    this.dialogRef.close();
  }

  async saveSensorSettings() {
    const payloadList: any[] = [];

    // Loop through all standard sensor metric rows
    this._sensorGroupData.forEach((sensor, idx) => {
      const updated = {
        id: sensor.id,
        base_value: Number((document.getElementById(`base_value_${idx}`) as HTMLInputElement)?.value),
        max_value: Number((document.getElementById(`max_value_${idx}`) as HTMLInputElement)?.value),
        threshold_1: Number((document.getElementById(`threshold_1_${idx}`) as HTMLInputElement)?.value),
        threshold_2: Number((document.getElementById(`threshold_2_${idx}`) as HTMLInputElement)?.value),
        threshold_3: Number((document.getElementById(`threshold_3_${idx}`) as HTMLInputElement)?.value)
      };

      // Push if values changed compared to original
      const orig = this.originalData.find((x: any) => x.id === sensor.id);

      if (
        updated.threshold_1 !== orig.threshold_1 ||
        updated.threshold_2 !== orig.threshold_2 ||
        updated.threshold_3 !== orig.threshold_3 ||
        updated.base_value !== orig.base_value ||
        updated.max_value !== orig.max_value
      ) {
        payloadList.push(updated);
      }
    });

    // Velocity (KWRATING) data
    this._sensorGroupData.forEach((sensor, idx) => {
      const updated = {
        id: sensor.id,
        base_value: Number((document.getElementById(`base_value_${idx}`) as HTMLInputElement)?.value),
        max_value: Number((document.getElementById(`max_value_${idx}`) as HTMLInputElement)?.value),
        threshold_1: Number((document.getElementById(`threshold_1_${idx}`) as HTMLInputElement)?.value),
        threshold_2: Number((document.getElementById(`threshold_2_${idx}`) as HTMLInputElement)?.value),
        threshold_3: Number((document.getElementById(`threshold_3_${idx}`) as HTMLInputElement)?.value)
      };

      const orig = this.originalData.find((x: any) => x.id === sensor.id);

      // --- ADDED CHECKS FOR base_value AND max_value BELOW ---
      if (
        updated.threshold_1 !== orig.threshold_1 ||
        updated.threshold_2 !== orig.threshold_2 ||
        updated.threshold_3 !== orig.threshold_3 ||
        updated.base_value !== orig.base_value ||
        updated.max_value !== orig.max_value
      ) {
        payloadList.push(updated);
      }
    });

    this.sensorKWpowerGroupData.forEach((sensor, idx) => {
      // FIX A: Iterate over sensorKWpowerGroupData, not _sensorGroupData

      const updated = {
        id: sensor.id,
        // FIX B: In your HTML, base_value is disabled, so we keep the original value from the object
        base_value: sensor.base_value,
        max_value: Number((document.getElementById(`threshold_3_dev${idx}`) as HTMLInputElement)?.value),

        // FIX C: Update IDs to match HTML (threshold_1_dev, threshold_2_dev, etc.)
        threshold_1: Number((document.getElementById(`threshold_1_dev${idx}`) as HTMLInputElement)?.value),
        threshold_2: Number((document.getElementById(`threshold_2_dev${idx}`) as HTMLInputElement)?.value),
        threshold_3: Number((document.getElementById(`threshold_3_dev${idx}`) as HTMLInputElement)?.value)
      };

      const orig = this.originalData.find((x: any) => x.id === sensor.id);

      if (
        updated.threshold_1 !== orig.threshold_1 ||
        updated.threshold_2 !== orig.threshold_2 ||
        updated.threshold_3 !== orig.threshold_3
      ) {
        payloadList.push(updated);
      }
    });

    console.log("Updated Sensors:", payloadList);


    // Make PUT request for each item
    for (const item of payloadList) {
      try {
        const response: any = await this.service.putData(`${BaseUrlConstantsService.ASSET_METRICS}/${item.id}`, item);

      } catch (err) {
        console.error("Update failed:", err);
      }
    }

    const firstItem = this.data.metrics[0];

    const new_kurt_threshold = Number((document.getElementById("kurt_threshold") as HTMLInputElement)?.value);
    const new_kurt_freq = Number((document.getElementById("kurt_frequency") as HTMLInputElement)?.value);
    const new_kurt_anomaly_counter = Number((document.getElementById("kurt_anomaly_counter") as HTMLInputElement)?.value);

    // Check if kurtosis values changed
    if (
      new_kurt_threshold !== firstItem.kurt_threshold ||
      new_kurt_freq !== firstItem.kurt_freq ||
      new_kurt_anomaly_counter !== firstItem.kurt_anomaly_counter
    ) {
      const kurtosisPayload = {
        kurt_freq: new_kurt_freq,
        kurt_threshold: new_kurt_threshold,
        kurt_anomaly_counter: new_kurt_anomaly_counter,
        asset_id: firstItem.asset_id,
        user_id: firstItem.user_id,
        index_ref: 10,
        id: "test_id"
      };

      console.log("Kurtosis Payload:", kurtosisPayload);

      try {
        await this.service.putData(`${BaseUrlConstantsService.ASSET_METRICS}/test_id`, kurtosisPayload);
      } catch (err) {
        console.error("Kurtosis update failed:", err);
      }
    }

    this.dialogRef.close(true);
  }

}
